import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface AlarmMetaDataState {
  isLoading: boolean
  error: string | undefined
  data: any | null
  httpStatus: number | undefined
}

export const initialState: AlarmMetaDataState = {
  isLoading: false,
  error: undefined,
  data: null,
  httpStatus: 0
}

const alarmMetaDataSlice = createSlice({
  name: 'AlarmMetaDataSlice',
  initialState,
  reducers: {
    alarmMetaDataLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: null,
        httpStatus: 0
      }
    },
    alarmMetaDataUpdateAction: (state, action: PayloadAction<{ data: any, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    alarmMetaDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  alarmMetaDataLoadingAction,
  alarmMetaDataUpdateAction,
  alarmMetaDataErrorAction
} = alarmMetaDataSlice.actions

export default alarmMetaDataSlice.reducer
